(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nurly-home-image-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nurly-image-scroll')) {
    class NurlyImageScroll extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('.nh-isc__viewport');
        if (!this.track || !this.track.children.length) return;
        const base = parseFloat(this.dataset.speed || '0.2');
        this.speed = (window.innerWidth <= 768 ? base * 0.3 : base) * 200; /* px/s */
        this.offset = 0;
        this.originals = Array.from(this.track.children).map((el) => el.cloneNode(true));
        this.fill();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.io = new IntersectionObserver((en) => en.forEach((e) => (e.isIntersecting ? this.play() : this.pause())), { threshold: 0.1 });
        this.io.observe(this);
        this._onResize = () => { clearTimeout(this._rt); this._rt = setTimeout(() => this.fill(), 200); };
        window.addEventListener('resize', this._onResize);
      }
      disconnectedCallback() {
        this.pause();
        if (this.io) this.io.disconnect();
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }
      fill() {
        const n = this.originals.length;
        const addSet = () => this.originals.forEach((el) => { const c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); this.track.appendChild(c); });
        /* Piste = nombre PAIR de jeux d'images couvrant au moins 2 écrans → boucle sans saut sur la moitié */
        let guard = 0;
        while ((this.track.scrollWidth < this.viewport.clientWidth * 2 || (this.track.children.length / n) % 2) && guard++ < 60) addSet();
        const half = this.track.children.length / 2;
        this.loop = this.track.children[half].offsetLeft - this.track.children[0].offsetLeft;
      }
      play() {
        if (this.raf) return;
        this.last = performance.now();
        const step = (ts) => {
          const dt = Math.min(50, ts - this.last) / 1000;
          this.last = ts;
          this.offset += this.speed * dt;
          if (this.loop > 0 && this.offset >= this.loop) this.offset %= this.loop;
          this.track.style.transform = `translateX(-${this.offset}px)`;
          this.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }
      pause() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }
    customElements.define('nurly-image-scroll', NurlyImageScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nurly-home-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nurly-ugc')) {
    class NurlyUgc extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        const root = this;
        const track = root.querySelector('[data-hl-track]');
        const slides = Array.from(root.querySelectorAll('[data-hl-slide]'));
        if (!track || !slides.length) return;
        const dotsWrap = root.querySelector('[data-hl-dots]');
        const titleEl = root.querySelector('[data-hl-title]');
        const textEl = root.querySelector('[data-hl-text]');
        const btnEl = root.querySelector('[data-hl-btn]');
        const carousel = root.querySelector('[data-hl-carousel]');
        const cursorEl = root.querySelector('[data-hl-cursor]');
        const prevBtn = root.querySelector('[data-hl-prev]');
        const nextBtn = root.querySelector('[data-hl-next]');
        const mq = (q) => window.matchMedia && window.matchMedia(q).matches;
        const canHover = mq('(hover:hover) and (pointer:fine)');
        const userUnmuted = new WeakSet();
        const userPaused = new WeakSet();
        let active = 0;
        const vid = (i) => (slides[i] ? slides[i].querySelector('video') : null);
        const safePlay = (v) => { try { const p = v.play(); if (p && p.catch) p.catch(() => {}); } catch (e) {} };
        const play = (i) => {
          const v = vid(i);
          if (!v || userPaused.has(v)) return;
          if (!userUnmuted.has(v)) v.muted = true;
          v.setAttribute('playsinline', '');
          safePlay(v);
        };
        const pause = (i) => {
          const v = vid(i);
          if (!v) return;
          try { v.pause(); } catch (e) {}
          v.muted = true;
          userUnmuted.delete(v);
          userPaused.delete(v);
          const m = slides[i].querySelector('[data-hl-mute]');
          if (m) m.classList.add('is-muted');
        };
        const dots = slides.map((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'nh-ugc__dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Vidéo ' + (i + 1));
          b.addEventListener('click', () => goTo(i));
          if (dotsWrap) dotsWrap.appendChild(b);
          return b;
        });
        const scrollToSlide = (i) => {
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        };
        const updateNav = () => {
          if (prevBtn) prevBtn.disabled = active <= 0;
          if (nextBtn) nextBtn.disabled = active >= slides.length - 1;
        };
        const setActive = (i) => {
          dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
          const s = slides[i];
          if (!s) return;
          if (titleEl) titleEl.textContent = s.dataset.title || '';
          if (textEl) textEl.textContent = s.dataset.text || '';
          if (btnEl) {
            const href = (s.dataset.btnLink || '').trim();
            if (href && s.dataset.btnLabel) {
              btnEl.hidden = false;
              btnEl.textContent = s.dataset.btnLabel;
              btnEl.setAttribute('href', href);
            } else btnEl.hidden = true;
          }
          if (i !== active) pause(active);
          active = i;
          play(i);
          updateNav();
        };
        const goTo = (i) => {
          const c = Math.max(0, Math.min(slides.length - 1, i));
          scrollToSlide(c);
          setActive(c);
        };
        if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(active - 1); });
        if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(active + 1); });
        slides.forEach((_, i) => { if (i !== 0) pause(i); });

        let raf = null;
        track.addEventListener('scroll', () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const x = track.getBoundingClientRect().left + 10;
            let best = 0, dist = Infinity;
            slides.forEach((s, idx) => {
              const d = Math.abs(s.getBoundingClientRect().left - x);
              if (d < dist) { dist = d; best = idx; }
            });
            if (best !== active) setActive(best);
          });
        }, { passive: true });

        /* Glisser à la souris (ordinateur) */
        let down = false, startX = 0, startLeft = 0, moved = false;
        track.addEventListener('mousedown', (e) => { down = true; moved = false; track.classList.add('is-dragging'); startX = e.pageX; startLeft = track.scrollLeft; });
        const end = () => { if (!down) return; down = false; track.classList.remove('is-dragging'); };
        track.addEventListener('mouseleave', end);
        track.addEventListener('mouseup', end);
        track.addEventListener('mousemove', (e) => {
          if (!down) return;
          e.preventDefault();
          const walk = (e.pageX - startX) * 1.2;
          if (Math.abs(walk) > 4) moved = true;
          track.scrollLeft = startLeft - walk;
        });
        track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

        /* Curseur « SCROLL » en verre (ordinateur) */
        if (canHover && carousel && cursorEl) {
          let rc = null, lx = 0, ly = 0;
          carousel.addEventListener('mouseenter', () => { cursorEl.style.display = 'flex'; });
          carousel.addEventListener('mouseleave', () => { cursorEl.style.display = 'none'; cursorEl.style.transform = 'translate(-9999px,-9999px)'; });
          carousel.addEventListener('mousemove', (e) => {
            lx = e.clientX; ly = e.clientY;
            if (rc) return;
            rc = requestAnimationFrame(() => {
              rc = null;
              const r = carousel.getBoundingClientRect();
              cursorEl.style.transform = `translate(${lx - r.left - 26}px, ${ly - r.top - 26}px)`;
            });
          });
        }

        /* Lecture uniquement quand la section est visible */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            entries.forEach((en) => { if (en.isIntersecting) play(active); else { const v = vid(active); if (v) try { v.pause(); } catch (e) {} } });
          }, { threshold: 0.25 }).observe(track);
        }

        /* Contrôles par carte */
        slides.forEach((slide, idx) => {
          const v = slide.querySelector('video');
          if (v) {
            v.removeAttribute('controls');
            const muteBtn = slide.querySelector('[data-hl-mute]');
            const ppBtn = slide.querySelector('[data-hl-playpause]');
            const seek = slide.querySelector('[data-hl-seek]');
            const syncPP = () => { if (ppBtn) { ppBtn.classList.toggle('is-paused', v.paused); ppBtn.setAttribute('aria-label', v.paused ? 'Lire' : 'Mettre en pause'); } };
            const syncMute = () => { if (muteBtn) { muteBtn.classList.toggle('is-muted', v.muted); muteBtn.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son'); } };
            v.addEventListener('play', syncPP);
            v.addEventListener('pause', syncPP);
            syncPP(); syncMute();
            [ppBtn, muteBtn, seek].forEach((el) => el && el.addEventListener('mousedown', (e) => e.stopPropagation()));
            if (ppBtn) ppBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              if (active !== idx) { userPaused.delete(v); setActive(idx); return; }
              if (v.paused) { userPaused.delete(v); safePlay(v); } else { userPaused.add(v); v.pause(); }
            });
            if (muteBtn) muteBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              if (active !== idx) setActive(idx);
              v.muted = !v.muted;
              if (v.muted) userUnmuted.delete(v); else { userUnmuted.add(v); safePlay(v); }
              syncMute();
            });
            if (seek) {
              let seeking = false;
              const fill = () => {
                const max = parseFloat(seek.max) || 0;
                seek.style.setProperty('--nh-seek', (max > 0 ? (parseFloat(seek.value) / max) * 100 : 0) + '%');
              };
              const setMax = () => { seek.max = v.duration || 0; fill(); };
              if (v.readyState >= 1) setMax();
              v.addEventListener('loadedmetadata', setMax);
              v.addEventListener('timeupdate', () => { if (!seeking) { seek.value = v.currentTime; fill(); } });
              seek.addEventListener('pointerdown', (e) => { e.stopPropagation(); seeking = true; });
              seek.addEventListener('input', (e) => { e.stopPropagation(); fill(); });
              seek.addEventListener('change', (e) => { e.stopPropagation(); v.currentTime = parseFloat(seek.value) || 0; seeking = false; });
            }
          }
          /* Retour visuel du bouton « Ajouter » (l'ajout est géré par quick-add-component → tiroir panier) */
          const atc = slide.querySelector('[data-hl-atc]');
          if (atc) {
            const label = atc.querySelector('[data-hl-atc-label]');
            const def = label ? label.textContent : '';
            atc.addEventListener('mousedown', (e) => e.stopPropagation());
            atc.addEventListener('click', () => {
              if (label) label.textContent = '...';
              const done = () => {
                document.removeEventListener('cart:updated', done);
                atc.classList.add('is-added');
                if (label) label.textContent = 'Ajouté ✓';
                setTimeout(() => { atc.classList.remove('is-added'); if (label) label.textContent = def; }, 1800);
              };
              document.addEventListener('cart:updated', done);
              setTimeout(() => { document.removeEventListener('cart:updated', done); if (label && label.textContent === '...') label.textContent = def; }, 8000);
            });
          }
        });
        setActive(0);
      }
    }
    customElements.define('nurly-ugc', NurlyUgc);
  }

  } catch(e) { console.error(e); }
})();
})();
